export const getSpotifyLink = (type, id) => {
  return `https://open.spotify.com/${type === 'song' ? 'track' : type}/${id}`
}

export const getYouTubeLink = (id, type) => {
  if (type === 'album') {
    return `https://www.youtube.com/playlist?list=${id}`
  }
  return `https://www.youtube.com/watch?v=${id}`
}

export const getBandcampLink = (url) => {
  return url
}

export const getAppleMusicLink = (type, id) => {
  if (type === 'song') {
    return `https://music.apple.com/us/song/${id}`
  } else if (type === 'album') {
    return `https://music.apple.com/us/album/${id}`
  } else if (type === 'playlist') {
    return `https://music.apple.com/us/playlist/${id}`
  }
  return '#'
}

export const getServiceLink = (item, type) => {
  // If service_links is available (cloud-based), use it
  if (item.service_links) {
    // Return all available service links
    const links = []
    for (const [serviceName, serviceData] of Object.entries(item.service_links)) {
      const { service_id, service_url } = serviceData
      if (service_url) {
        links.push({
          service_name: serviceName,
          url: service_url,
        })
      } else if (service_id) {
        let url
        switch (serviceName) {
          case 'spotify':
            url = getSpotifyLink(type, service_id)
            break
          case 'apple_music':
            url = getAppleMusicLink(type, service_id)
            break
          case 'youtube':
            url = getYouTubeLink(service_id, type)
            break
          case 'bandcamp':
            url = service_url // Bandcamp always uses service_url
            break
          default:
            url = null
        }
        if (url) {
          links.push({
            service_name: serviceName,
            url,
          })
        }
      }
    }
    return links
  }

  // Legacy fallback for single service
  if (!item.service_name) return null

  switch (item.service_name) {
    case 'spotify':
      return item.service_id
        ? [{ service_name: 'spotify', url: getSpotifyLink(type, item.service_id) }]
        : null
    case 'apple_music':
      return item.service_id
        ? [{ service_name: 'apple_music', url: getAppleMusicLink(type, item.service_id) }]
        : null
    case 'youtube':
      return item.service_id
        ? [{ service_name: 'youtube', url: getYouTubeLink(item.service_id, type) }]
        : null
    case 'bandcamp':
      return item.service_url ? [{ service_name: 'bandcamp', url: item.service_url }] : null
    default:
      return null
  }
}
